const root = "/orders";

export const orderRoutes = {
  root: root,
  detail: (odNumber: string) => ({
    root: `${root}/${odNumber}`,
    history: `${root}/${odNumber}/history`,
    document: `${root}/${odNumber}/document`,
  }),
};
